import React, { Component } from 'react'
import { get } from 'lodash'
import EquipmentList from './EquipmentList'
import equipmentData from './equipment_list.json'
import popup from '../../popup'
import './index.css'

class Equipment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedEquipment: get(this.props, 'selectedEquipment', []),
      user: 'Nate'
    }
  }

  onSelect = val => evt => {
    evt.preventDefault()
    this.setState(({ selectedEquipment: oldEquipment }) => {
      const updatedEquipment = oldEquipment.includes(val)
        ? oldEquipment.filter(e => e !== val)
        : [...oldEquipment, val]
      return { selectedEquipment: updatedEquipment }
    })
  }

  clickNext = e => {
    e.preventDefault()
    alert(`You selected ${this.state.selectedEquipment.join(', ')}`)
  }

  render() {
    const { state: { user, selectedEquipment }, props: { profile, saveProfile } } = this;
    return (
      <div className="equipment-container">
        <div className="neou-main">
          <h1 className="neou-equipment-heading">Equipment Selection</h1>
          <p className="neou-equipment-question" style={{ display: profile ? 'none' : 'block' }}>
            Hey {user}, What kind of Equipment do you have today?
          </p>
          <EquipmentList 
            onSelect={this.onSelect} 
            selectedEquipment={selectedEquipment} 
            equipment={equipmentData} 
            profile={profile}
          />
          { profile ? 
            <div className="neou-profile-button">
              <button onClick={() => saveProfile(selectedEquipment)}>Save</button>
            </div> :
            <div className="neou-equipment-buttons">
              <button className="neou-equipment-button" onClick={() => {
                if (sessionStorage.getItem('eq')) {
                  sessionStorage.setItem('eq', sessionStorage.getItem('eq') - 1);
                }
                popup.hide()}
              }>
              Skip
              </button>
              <button className="neou-equipment-button" onClick={() => popup.hide()}>
                Next
              </button>
            </div> }
        </div>
      </div>
    )
  }
}

export default Equipment;
